import { selectIsSubAccount } from 'selectors/account';
import {
  isBankAccountAddedSelector,
  isUserKycDoneSelector,
  isUserLoggedInSelector,
  selectUserBanners,
  selectUserKycVerifiedDate,
  selectUserLast30DayTradingVolume,
  selectUserLoginCount,
  selectUserRegistrationDate,
  userAddressProofSelector,
  userDepositsSelector,
  userIdentityProofSelector,
} from 'selectors/otherSelectors';
import { selectShowDoKycCard } from 'selectors/user';
import { useAppSelector } from 'storeHooks';

import { cardToDisplayForUserJourney } from './UserJourneyCard.helpers';
import { USER_JOURNEY_CARDS } from './UserJourneyCard.types';

const useUserJourneyCard = (): USER_JOURNEY_CARDS | null => {
  const bannersMap = useAppSelector(selectUserBanners);

  const depositInfo = useAppSelector(userDepositsSelector);

  const proofOfAddressStatus = useAppSelector(userAddressProofSelector);

  const proofOfIdentityStatus = useAppSelector(userIdentityProofSelector);

  const isKycDone = useAppSelector(isUserKycDoneSelector);

  const isBankAccountAdded = useAppSelector(isBankAccountAddedSelector);

  const registrationDate = useAppSelector(selectUserRegistrationDate);

  const loggedIn = useAppSelector(isUserLoggedInSelector);

  const loginCount = useAppSelector(selectUserLoginCount);

  const last30DayTradingVolume = useAppSelector(selectUserLast30DayTradingVolume);

  const kycVerifiedOn = useAppSelector(selectUserKycVerifiedDate);

  const isSubAccount = useAppSelector(selectIsSubAccount);

  const showDoKycCard = useAppSelector(selectShowDoKycCard);

  return isSubAccount
    ? null
    : cardToDisplayForUserJourney({
        banners: bannersMap,
        depositInfo,
        isKycDone,
        kycVerifiedOn,
        last30DayTradingVolume,
        loggedIn,
        loginCount,
        proofOfAddressStatus,
        proofOfIdentityStatus,
        registrationDate,
        isBankAccountAdded,
        showDoKycCard,
      });
};

export default useUserJourneyCard;
